import { IPrinter } from "@/androidPlugins/IPrinter"
import type {
  CashierEndOfDayReport,
  EndOfDayReportMetrics,
  RetreiveEndOfDayReportResponse,
} from "../reports/retreiveEndOfDayReport"

const { formatToMerchantCurrencyString } = useCurrency()
const { name } = useTenant()
const { serialNumber } = useDevice()

const formatDoubleLine = (
  label: string,
  count: number,
  amount: number
) =>
  getDoubleDataLine(
    label,
    count.toString(),
    formatToMerchantCurrencyString(amount)
  )

const getMetricLines = (metrics: EndOfDayReportMetrics) => {
  const entries: Array<[string, number, number]> = [
    [
      "Card Sales",
      metrics.cardTransactionCount,
      metrics.cardTransactionAmount,
    ],
    [
      "Cash Sales",
      metrics.cashTransactionCount,
      metrics.cashTransactionAmount,
    ],
    [
      "Card Refunds",
      metrics.cardRefundCount,
      metrics.cardRefundAmount,
    ],
    [
      "Cash Refunds",
      metrics.cashRefundCount,
      metrics.cashRefundAmount,
    ],

    [
      "Sale Voids",
      metrics.saleVoidCount,
      metrics.saleVoidAmount,
    ],
    [
      "Refund Voids",
      metrics.refundVoidCount,
      metrics.refundVoidAmount,
    ],
    [
      "CASHBACK",
      metrics.cashbackCount,
      metrics.cashbackAmount,
    ],
  ]

  return entries
    .map(([label, count, amount]) =>
      formatDoubleLine(label, count, amount)
    )
    .join("")
}

const getCashierBreakdownSection = (
  cashierBreakdown: CashierEndOfDayReport[]
) => {
  if (cashierBreakdown.length === 0) {
    return ""
  }

  return (
    getBlankLines(1) +
    getDataLine("Split By Cashier", null, true) +
    cashierBreakdown
      .map(
        (cashierReport) =>
          getBlankLines(1) +
          getDataLine(
            cashierReport.cashierName ?? "Default",
            null,
            true
          ) +
          getMetricLines(cashierReport)
      )
      .join("")
  )
}

export const formatEndOfDayReport = (
  report: RetreiveEndOfDayReportResponse
) => {
  const formattedReceipt =
    getDataLine(name.value, null, true) +
    getDataLine(serialNumber.value, "S/N", true) +
    getDataLine(
      new Date().toLocaleDateString(),
      null,
      true
    ) +
    getBlankLines(1) +
    getDataLine("End of day report", null, true) +
    getBlankLines(1) +
    getMetricLines(report) +
    getBlankLines(1) +
    "Inclusive Of \n" +
    getDataLine(
      formatToMerchantCurrencyString(
        report.cardGratuityAmount
      ),
      "Card Gratuity"
    ) +
    getDataLine(
      formatToMerchantCurrencyString(
        report.cashGratuityAmount
      ),
      "Cash Gratuity"
    ) +
    getCashierBreakdownSection(report.cashierBreakdown)

  return formattedReceipt
}

export const printEndOfDayReport = async (
  report: RetreiveEndOfDayReportResponse
) => {
  await IPrinter.printStr({
    str: formatEndOfDayReport(report),
  })
}
